import type { ReactNode } from "react";

type Props = {
  tone: "bright" | "muted";
  eyebrow: string;
  headline: ReactNode;
  items: string[];
  footer: ReactNode;
  footerEyebrow?: string;
};

export function QualificationCard({
  tone,
  eyebrow,
  headline,
  items,
  footer,
  footerEyebrow,
}: Props) {
  const bg = tone === "bright" ? "bg-white" : "bg-bg-subtle";
  return (
    <div
      className={`flex h-full flex-col rounded-2xl ${bg} p-7 shadow-[0_2px_12px_rgba(15,23,42,0.06)] lg:p-10`}
    >
      <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-3 opacity-80">
        {eyebrow}
      </div>
      <h3 className="mt-3 font-display text-[clamp(22px,2vw,26px)] font-semibold leading-tight text-ink">
        {headline}
      </h3>
      <div className="mt-4 h-px w-10 bg-lime" />

      <ul className="mt-6 space-y-4">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3 text-base leading-[1.6] text-ink-2">
            <span
              aria-hidden
              className="mt-[10px] inline-block h-1.5 w-1.5 flex-shrink-0 rounded-full bg-lime"
            />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto pt-8">
        <div className="border-t border-rule pt-6">
          {footerEyebrow && (
            <div className="mb-3 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-3 opacity-80">
              {footerEyebrow}
            </div>
          )}
          <p
            className={`text-base leading-[1.7] ${
              footerEyebrow ? "text-ink-3" : "text-ink-2"
            }`}
          >
            {footer}
          </p>
        </div>
      </div>
    </div>
  );
}
